import clsx from 'clsx'

interface Props {
  elevate?: boolean
  smallRadius?: boolean
  children: React.ReactNode
  className?: string
  id?: string
  onClick?: () => void
  style?: React.CSSProperties
}

const Card = ({
  elevate = false,
  smallRadius = false,
  children,
  className,
  id,
  onClick,
  style,
}: Props) => {
  if (elevate) {
    return (
      <div
        id={id}
        className={clsx(
          'p-4 bg-white overflow-hidden',
          smallRadius ? 'rounded-lg' : 'rounded-xl',
          className
        )}
        style={{ boxShadow: '0px 3.73px 18.65px 18.65px #00000005', ...style }}
        onClick={onClick}
      >
        {children}
      </div>
    )
  }

  return (
    <div
      className={clsx(
        'p-2 flex flex-col border border-solid border-[#CDD2D4] rounded-md',
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export default Card
